import 'core-js/features/object/from-entries';
import 'intersection-observer';
